import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { AvpAPI } from "../../../services";

type UseIsAgeVerificationHidden = {
  isAgeVerificationHidden?: boolean;
  isAgeVerificationHiddenLoading: boolean;
};

export const useIsAgeVerificationHidden = (): UseIsAgeVerificationHidden => {
  const { data: isAgeVerificationHidden, isFetching: isAgeVerificationHiddenLoading } = useQuery(
    QUERY_KEYS.ageVerificationHidden,
    () => AvpAPI.init().isAgeVerificationHidden(),
    {
      staleTime: Infinity,
    }
  );

  return {
    isAgeVerificationHidden,
    isAgeVerificationHiddenLoading,
  };
};
